export default __webpack_public_path__ + "static/media/augusto.7b602bf2.png";